import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/Services/api.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'g10-manage-group-add-form',
  templateUrl: './manage-group-add-form.component.html',
  styleUrls: ['./manage-group-add-form.component.css']
})
export class ManageGroupAddFormComponent implements OnInit {

  @Input() popup = false ;
  @Input() type;

  @Output() closeEvent: any = new EventEmitter();
  @Output() result: any = new EventEmitter();

  public hideField:boolean = true;

  public manageGroupForm:FormGroup;

  //chip configuration
  public selectable = true;
  public removable = true;
  public emails = [];
  public mobiles = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];

  public formSubmit:boolean =false;

  constructor(
    private api: ApiService,
    private swal: SweetAlert,
    public fb: FormBuilder
  ) { }

  ngOnInit(): void {
    console.log(this.type);
    this.addManageGroupFormLoad();
  }

  addManageGroupFormLoad(){ 
    let formObject = {
      groupName:this.fb.control('',[Validators.required]),
    };
    if(this.type=='email'){
      formObject['emailID'] = this.fb.control('',[Validators.required]);
      
    }
    else if(this.type=='mobile'){
      formObject['mobileNo'] = this.fb.control('',[Validators.required]);
    }
    this.manageGroupForm = this.fb.group(formObject);
  }

  transformTitlecase(event,field){
    if(event.value != ''){
      event.value = event.value.charAt(0).toUpperCase()+event.value.slice(1);
      this.manageGroupForm.controls[field].patchValue(event.value);
    }
  }


  removeEmail(email,index){
    //const index = this.emails.indexOf(email);

    if (index >= 0) {
      this.emails.splice(index, 1);
      this.patchEmail();
      let isInValid = false;
      this.emails.filter((email)=>{
        if(email.invalid){
          isInValid = true;
        }
      });

      if(isInValid) this.manageGroupForm.controls.emailID.setErrors({'email':true}); 
      else this.manageGroupForm.controls.emailID.setErrors(null);
    }
  }
  addEmail(event){
    const value = (event.value || '').trim();

    // Add our email
    if (value) {
      console.log(value,this.validateEmail(value));
      if(this.validateEmail(value)){
      this.emails.push({ value: event.value, invalid: false });
      this.patchEmail();
      this.checkEmail();
      } 
      else {
        this.emails.push({ value: event.value, invalid: true });
        //this.manageGroupForm.controls['email'].setErrors({'incorrectEmail': true});
        this.manageGroupForm.controls.emailID.setErrors({'email':true})
        console.log(this.manageGroupForm.controls);
      }
    // Clear the input value
    console.log(event);
    if (event.input) {
      event.input.value = '';
    }
    //event.chipInput!.clear();
    //this.manageGroupForm.value.email.setValue(null);

    }
  }

  removeMobile(mobile,index){
    //const index = this.mobiles.indexOf(mobile);

    if (index >= 0) {
      this.mobiles.splice(index, 1);
      this.patchMobile();
      let isInValid = false;
      this.mobiles.filter((mobile)=>{
        if(mobile.invalid){
          isInValid = true;
        }
      });

      if(isInValid) this.manageGroupForm.controls.mobileNo.setErrors({'mobile':true}); 
      else this.manageGroupForm.controls.mobileNo.setErrors(null);
    }
  }
  addMobile(event){
    const value = (event.value || '').trim();

    // Add our email
    if (value) {
      if(this.validateMobile(value)){
      this.mobiles.push({ value: event.value, invalid: false });
      this.patchMobile();
      this.checkMobile();
      } 
      else {
        this.mobiles.push({ value: event.value, invalid: true });
        //this.manageGroupForm.controls['email'].setErrors({'incorrectEmail': true});
        this.manageGroupForm.controls.mobileNo.setErrors({'mobile':true})
        console.log(this.manageGroupForm.controls);
      }
    // Clear the input value
    console.log(event);
    if (event.input) {
      event.input.value = '';
    }
    //event.chipInput!.clear();
    //this.manageGroupForm.value.email.setValue(null);

    }
  }
  
  private validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  private validateMobile(mobile){
    var mobileVal = /^((\\+91-?)|0)?[0-9]{10}$/;
    return mobileVal.test(mobile);
  }

  public checkError = (controlName: string, errorName: string) => {
    console.log('controlName',controlName,this.manageGroupForm.controls);
    return this.manageGroupForm.controls[controlName].hasError(errorName);
  }

  checkMobile(){
    if(this.checkError('mobileNo','required'))   return true;
    else if(this.checkError('mobileNo','mobile'))  return true;
    else return false;
  }
  checkEmail(){
    if(this.checkError('emailID','required')) return true;
    else if(this.checkError('emailID','email')) return true;
    else return false;
  }
  
  patchEmail(){
    let values = []
    this.emails.filter((email)=> values.push(email.value));
    console.log(values);
    this.manageGroupForm.controls.emailID.patchValue(values);
    
  }
  patchMobile(){
    let values = [];
    this.mobiles.filter((mobile)=> values.push(mobile.value));
    this.manageGroupForm.controls.mobileNo.patchValue(values);
  }

  onSubmit(){
    this.formSubmit = true;
    let InvalidForm = false;
    if(this.type == 'email'){
      InvalidForm = this.checkEmail();
    }
    else if(this.type == 'mobile'){
      InvalidForm = this.checkMobile();
    }
    console.log(InvalidForm);
    if(this.manageGroupForm.valid && !InvalidForm){
      let obj = {
        type:this.type,
        ...this.manageGroupForm.value,
      }
      console.log(obj);
      this.api.transportManagerManageGroupCreate(obj).then((res: any) => {
        if (res.status == 'success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          setTimeout(()=>{
            this.result.emit(false);
            this.closeEvent.emit(false);
          },2500);
        } else {
          this.swal.swalFunction('error', res.status, res.message, 2000);
        }
      });
    }
  }

}
